'use client';

import type { UnitPackPricingContent } from '@/core/types';

import React from 'react';

import { UnitPackPricing } from '@/containers/blocks/features';

export default function UnitPackPricingGenerator({
  content,
  className,
}: {
  content: UnitPackPricingContent;
  className?: string;
}) {
  return (
    <UnitPackPricing
      title={content?.title}
      subtitle={content?.subtitle}
      durations={content?.durations}
      buttons={content?.buttons}
      categories={content?.categories}
      units={content?.units}
      className={className}
    />
  );
}
